import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { reduxForm, Field, formValueSelector } from "redux-form"
import { compose } from "recompose"
import { connect } from "react-redux"
import debounce from "lodash.debounce"
import { Info } from "react-feather"
import { Popover } from "antd"
import { FormattedMessage, injectIntl } from "react-intl"
import SegmentedControlManager from "../../components/segmented-control/segmented-control-manager.component"
import SegmentedControl from "../../components/segmented-control/segmented-control.component"
import Box from "../../lib/ui/ui-box"
import Text from "../text"
import RatesActions from "../../containers/rates/rates.redux"
import { store } from "../../index"

const renderSegmentedControl = props => (
  <SegmentedControl {...props} {...props.input} />
)

const PopoverContentOne = (
  <Box flexDirection="column" w="250px">
    <Text>
      <FormattedMessage id="rates.tooltips.term.p1" />
    </Text>
  </Box>
)

const PopoverContentTwo = (
  <Box flexDirection="column" w="250px">
    <Text>
      <FormattedMessage id="rates.tooltips.rate.p1" />
    </Text>
    <Text mt={[1]}>
      <FormattedMessage id="rates.tooltips.rate.p2" />
    </Text>
  </Box>
)

class RatesAsideForm extends PureComponent {
  static propTypes = {
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired
  }

  render() {
    const { initialValues, intl } = this.props
    return (
      <Box>
        <Box flexDirection="column" pt={[1]}>
          <Box flexDirection="column" mt={[2]}>
            <Box flexDirection="row" align="center">
              <Text fontSize={[0]} mr={[0]}>
                <FormattedMessage id="rates.tooltips.rate.title" />
              </Text>
              <Popover
                content={PopoverContentTwo}
                title={intl.formatMessage({ id: "rates.tooltips.rate.title" })}
                placement="rightTop"
              >
                <Info size={20} color="#D8D8D8" />
              </Popover>
            </Box>
            <SegmentedControlManager options={initialValues.rates}>
              {({ options: _options, value }) => (
                <Field
                  name="selectedRate"
                  width={240}
                  options={_options}
                  value={value}
                  component={renderSegmentedControl}
                />
              )}
            </SegmentedControlManager>
          </Box>

          <Box flexDirection="column" mt={[2]}>
            <Box flexDirection="row" align="center">
              <Text fontSize={[0]} mr={[0]}>
                <FormattedMessage id="rates.tooltips.term.title" />
              </Text>
              <Popover
                content={PopoverContentOne}
                title={intl.formatMessage({ id: "rates.tooltips.term.title" })}
                placement="rightTop"
              >
                <Info size={20} color="#D8D8D8" />
              </Popover>
            </Box>
            <SegmentedControlManager options={initialValues.terms}>
              {({ options: _options, value }) => (
                <Field
                  name="selectedTerm"
                  width={240}
                  options={_options}
                  value={value}
                  component={renderSegmentedControl}
                />
              )}
            </SegmentedControlManager>
          </Box>
        </Box>
      </Box>
    )
  }
}

const selector = formValueSelector("ratesQueryForm")
const mapStateToProps = (state, ownProps) => {
  const rates = [
    {
      label: ownProps.intl.formatMessage({
        id: "rates.aside.rate_button_variable"
      }),
      value: "Variable"
    },
    {
      label: ownProps.intl.formatMessage({
        id: "rates.aside.rate_button_fixed"
      }),
      value: "Fixed"
    }
  ]
  const terms = [
    {
      label: ownProps.intl.formatMessage({ id: "rates.aside.term_button_3" }),
      value: 3
    },
    {
      label: ownProps.intl.formatMessage({ id: "rates.aside.term_button_5" }),
      value: 5
    }
  ]

  const initialValues = {
    rates,
    terms,
    propertyValue: ownProps.cfPropertyValue,
    cfMortgageType: ownProps.cfMortgageType,
    selectedRate: state.rates.query.WHERE.type,
    selectedTerm: state.rates.query.WHERE.term
  }
  return {
    initialValues,
    propertyValueAsInt: Number(selector(state, "propertyValue"))
  }
}

const updateStore = WHERE => {
  store.dispatch(RatesActions.updateRatesQuery({ WHERE }))
}

const debouncedUpdate = debounce(updateStore, 400)

export default compose(
  connect(
    mapStateToProps,
    null
  ),
  reduxForm({
    form: "ratesQueryForm",
    destroyOnUnmount: false,
    onChange({ selectedRate, selectedTerm }) {
      const WHERE = {
        ltv: 80,
        type: selectedRate,
        term: Number(selectedTerm)
      }
      debouncedUpdate(WHERE)
    }
  }),
  injectIntl
)(RatesAsideForm)



// WEBPACK FOOTER //
// ./src/components/rates-aside-form/rates-aside-form.component.js